<template>
  <!-- 记笔记 -->
  <el-tabs
    class="ori-uni-notes-drawer"
    v-model="noteActiveTab0"
    type="border-card"
  >
    <!-- 目录 -->
    <el-tab-pane name="subject">
      <span slot="label"> <i class="iconfont iconmulu1"></i> 目录 </span>
      <Catalog
        ref="catalog"
        :lessonsUuidPr="lessonsUuid"
        :datas="sectionDtos"
        @change="lessonChange"
      />
    </el-tab-pane>
    <!-- 笔记 -->
    <el-tab-pane name="note">
      <span slot="label"> <i class="iconfont icontousujianyi"></i> 笔记 </span>

      <div class="ej-tab">
        <el-tabs @tab-click="noteTabChange" v-model="noteActiveTab2">
          <!-- 我的笔记 -->
          <el-tab-pane label="我的笔记" name="myNote">
            <div class="notes-pane">
              <div id="noteEdit">
                <el-input
                  v-model="noteContent"
                  placeholder="输入笔记内容"
                  type="textarea"
                  rows="5"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </div>
              <div class="note-refer">
                <el-button @click="addNotes" class="note-btn" type="primary"
                  >记笔记</el-button
                >
                <el-checkbox v-model="isPublic" :true-label="1" :false-label="0"
                  >公开</el-checkbox
                >
              </div>

              <!-- 笔记列表 -->
              <ul class="note-lists mat50">
                <li class="item" v-for="item in myNotes" :key="item.id">
                  <p class="date">
                    <span>{{ item.created_at }}</span>
                    <span>
                      <i
                        @click="editMyNoteHandler(item)"
                        class="iconfont iconjibiji"
                      ></i>
                      <!-- <el-popconfirm
                        confirm-button-text="确定"
                        cancel-button-text="取消"
                        icon="el-icon-info"
                        iconColor="red"
                        title="确定删除?删除后不能恢复!"
                        @confirm="deleteNote(item.id)"
                      > -->
                      <i
                        slot="reference"
                        class="iconfont iconshanchu"
                        @click="deleteNote(item.id)"
                      ></i>
                      <!-- </el-popconfirm> -->
                    </span>
                  </p>
                  <div
                    class="con"
                    v-html="$xss(item.content.replace(/\n/g, '<br/>'))"
                  ></div>
                  <p style="text-align: right; margin-top: 10px">
                    <el-checkbox
                      v-model="item.is_open"
                      :true-label="1"
                      :false-label="0"
                      @change="updateIsPublic(item)"
                      >公开</el-checkbox
                    >
                  </p>
                </li>
              </ul>
            </div>
          </el-tab-pane>

          <!-- 大家的笔记 -->
          <el-tab-pane label="大家的笔记" name="otherNote">
            <div class="notes-pane">
              <!-- 笔记列表 -->
              <ul class="note-lists">
                <li class="item" v-for="item in othersNotes" :key="item.uuid">
                  <div class="other-date">
                    <el-image
                      style="
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-right: 10px;
                      "
                      :src="item.student_thumb"
                      fit="cover"
                    >
                      <img
                        style="width: 100%"
                        slot="error"
                        src="@/assets/images/headEmpty.png"
                        alt="暂无头像"
                      />
                    </el-image>

                    <div>
                      <p>{{ item.student_title }}</p>
                      <p class="gray-light">{{ item.created_at }}</p>
                    </div>
                  </div>
                  <div
                    class="con"
                    v-html="$xss(item.content.replace(/\n/g, '<br/>'))"
                  ></div>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-tab-pane>
    <!-- 答疑 -->
    <!--<el-tab-pane name="answer">
      <span slot="label"> <i class="iconfont icondayi"></i> 答疑 </span>

      <div class="answer-box">
        <ul class="answer-lists">
          <li class="item" v-for="item in questions" :key="item.id">
            <p class="date">{{ item.created_at }}</p>
            <div class="con">
              <p class="row">
                <span class="mar10">问:</span>
                <span>{{ item.question }}？</span>
              </p>
              <div class="row mat10">
                <span class="mar10 primary">答:</span>
                <div class="answer-con">{{ item.answer }}</div>
              </div>
            </div>
          </li>
        </ul>

        <div class="answer-types">
          <el-input
            v-model="questionContent"
            placeholder="请在此提出您的问题"
          ></el-input>
          <el-button @click="addAnswer" type="primary" class="mal10"
            >发送</el-button
          >
        </div>
      </div>
    </el-tab-pane>-->
    <!-- 老师简介 -->
    <el-tab-pane name="teacher">
      <span slot="label">
        <i class="el-icon-postcard" style="font-size: 16px"></i> 老师简介
        <!-- <img style="width: 17px;height: 17px;" src="@/assets/images/19_red.png" alt=""> -->
      </span>
      <div v-if="teacherDatas && teacherDatas.content" style="text-indent: 2em; line-height: 30px; text-align: justify">
        {{ teacherDatas.content }}
      </div>
      <div v-else style="text-indent: 2em; line-height: 30px; text-align: justify">暂无简介</div>
      <div class="answer-box"></div>
    </el-tab-pane>
    <!-- 编辑笔记弹窗 -->
    <el-dialog title="修改笔记" :visible.sync="isEditVisible" width="30%">
      <div id="noteEdit">
        <el-input
          v-model="editMyNote.content"
          placeholder="输入笔记内容"
          type="textarea"
          rows="5"
        ></el-input>
      </div>
      <div class="note-refer">
        <el-button @click="updateNotes" class="note-btn" type="primary"
          >修改笔记</el-button
        >
        <el-checkbox
          v-model="editMyNote.is_open"
          :true-label="1"
          :false-label="0"
          >公开</el-checkbox
        >
      </div>
    </el-dialog>
  </el-tabs>
</template>

<script>
import Catalog from "./catalog";
import {
  getMyNotes,
  getNotes,
  addNotes,
  deleteMyNote,
  updateIsPublic,
  addQuestionAnswer,
  selectQuestionAnswers,
} from "@/api/basic";
export default {
  name: "Notes",
  components: {
    Catalog, //目录
  },
  props: {
    // 课节id
    lessonsUuid: {
      type: Number,
    },
    // 目录
    courseDatas: {
      type: Array,
    },
    teacherDatas: {
      type: [Array, Object],
    },
  },
  watch: {
    lessonsUuid(val) {
      this.getMyNotes(val);
      this.getAnswer();
    },
    courseDatas(val) {
      if (val) {
        this.sectionDtos = val;
      }
    },
  },
  data() {
    return {
      sectionDtos: [],
      isEditVisible: false,
      publicRadio: "1",
      noteActiveTab0: "subject",
      noteActiveTab1: "note",
      noteActiveTab2: "myNote",
      noteActiveTab3: "myCourseware",
      myNotes: [],
      othersNotes: [],
      editMyNote: {},
      isPublic: 1,
      noteContent: "",
      questions: [],
      questionContent: "",
      filePathData: "",
      titleName: "",
      fileName: "",
    };
  },
  mounted() {
    if (this.lessonsUuid) {
      this.getMyNotes(this.lessonsUuid);
      this.getAnswer();
    }
  },
  methods: {
    /**
     * 查询我的笔记
     */
    async getMyNotes(lessonsUuid) {
      const params = {
        section_id: lessonsUuid,
        page: 1,
        limit: 99999,
      };
      const { result } = await getMyNotes(params);
      if (result) {
        this.myNotes = result.list;
      }
    },
    /**
     * 新增编辑我的笔记
     */
    async addNotes() {
      if (this.noteContent == "") return;

      const params = {
        section_id: this.lessonsUuid,
        content: this.noteContent,
        is_open: this.isPublic,
      };

      const res = await addNotes(params);
      if (res.code == 200) {
        this.noteContent = "";
        this.isPublic = 1;
        this.getMyNotes(this.lessonsUuid);
      }
    },
    editMyNoteHandler(item) {
      this.isEditVisible = true;
      this.editMyNote = {
        ...item,
      };
    },
    async updateNotes() {
      if (this.editMyNote.content == "") {
        return;
      }

      const params = {
        id: this.editMyNote.id,
        section_id: this.editMyNote.section_id,
        content: this.editMyNote.content,
        is_open: this.editMyNote.is_open,
      };
      const res = await addNotes(params);

      if (res.code == 200) {
        this.$message.success("修改成功");
        this.getMyNotes(this.lessonsUuid);
        this.isEditVisible = false;
      }
    },
    /**
     * 修改笔记状态
     */
    async updateIsPublic(item) {
      const params = {
        id: item.id,
        is_open: item.is_open,
      };
      await updateIsPublic(params);
    },

    /**
     * 删除我的笔记
     */
    deleteNote(uuid) {
      this.$confirm("删除后不可恢复，是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.delNote(uuid);
      });
    },
    async delNote(uuid) {
      const params = {
        id: uuid,
      };
      const res = await deleteMyNote(params);
      if (res.code == 200) {
        this.getMyNotes(this.lessonsUuid);
        this.$message({
          message: "删除成功",
          type: "success",
        });
      }
    },
    /**
     * 查询大家的笔记
     */
    async getNotes(lessonsUuid) {
      const params = {
        section_id: lessonsUuid,
        page: 1,
        limit: 99999,
      };
      const { result } = await getNotes(params);
      if (result) {
        this.othersNotes = result.list;
      }
    },
    /**
     * tab标签切换
     */
    noteTabChange() {
      let noteActiveTab2 = this.noteActiveTab2;
      if (noteActiveTab2 == "myNote") {
        this.getMyNotes(this.lessonsUuid);
      } else if (noteActiveTab2 == "otherNote") {
        this.getNotes(this.lessonsUuid);
      }
    },
    /**
     * 新增答疑
     */
    async addAnswer() {
      if (this.questionContent == "") {
        this.$message({
          message: "问题内容不能为空",
          type: "warning",
        });
        return;
      }
      const params = {
        question: this.questionContent,
        section_id: this.lessonsUuid,
      };
      const res = await addQuestionAnswer(params);
      if (res.code == 200) {
        this.questionContent = "";
        this.getAnswer();
        this.$message({
          message: "提交成功，请前往消息中心查看回复。",
          type: "success",
        });
      }
    },
    /**
     *查询答疑
     */
    async getAnswer() {
      const params = {
        section_id: this.lessonsUuid,
        start: 1,
        perPage: 9999, //不分页，查询全部传9999
      };
      const { result } = await selectQuestionAnswers(params);
      if (result) {
        this.questions = result.list;
      }
    },
    // 切换视频
    lessonChange(lessonsUuid) {
      this.$emit("change", lessonsUuid);
    },
  },
};
</script>

<style lang="scss">
.ori-uni-notes-drawer {
  display: flex;
  flex-direction: column;
  height: 100%;

  .el-tabs--border-card {
    border: none;
    box-shadow: none;
  }

  .el-tabs__nav {
    width: 100%;
  }
  .el-tabs__item {
    width: calc(100% / 4);
    height: 60px;
    line-height: 60px;
    text-align: center;
    padding: 0 !important;
  }
  .el-tabs__content {
    flex: 1 1 auto;
  }
  .el-tab-pane {
    height: 100%;
  }

  .ej-tab {
    height: 100%;

    .el-tabs {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }
}
.coursewareUl li {
  display: flex;
  border-bottom: 1px solid #e1e1e1;
  padding: 20px 0;
  position: relative;
  .PDFImg {
    width: 56px;
    height: 66px;
    margin-right: 20px;
  }
  .coursewareUlDiv {
    display: flex;
    justify-content: center;
    flex-direction: column;
    p {
      &:first-child {
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      // &:nth-child(2) {
      //   font-size: 14px;
      //   color: #666;
      // }
      // &:last-child {
      //   font-size: 12px;
      //   color: #999;
      // }
    }
  }
  .dowData {
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    right: 10px;
    bottom: 7px;
    cursor: pointer;
    em {
      width: 20px;
      height: 20px;
      background: url("~@/assets/images/downloadIcon.png") no-repeat;
      background-size: cover;
    }
    span {
      font-size: 12px;
      color: #333;
    }
  }
}
</style>
<style lang="scss" scoped>
$rightW: 400px;
// $answerBox: calc(100vh - 20px - 60px - 70px);
// $notesPane: calc(100vh - 20px - 60px - 70px - 60px);
.ori-uni-notes-drawer {
  width: 100%;
  .note-refer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }
  .note-btn {
    display: block;
    width: 220px;
    height: 30px;
    padding: 0;
  }
  .notes-pane {
    // height: $notesPane;
    height: 100%;
    @extend %overScroll;
  }

  .note-lists {
    .item {
      margin-bottom: 30px;
      .date {
        display: flex;
        align-items: center;
        height: 30px;
        justify-content: space-between;
        border-bottom: 1px solid #eeeeee;

        .iconfont {
          margin-left: 10px;
          @include fontColor("primary");
          cursor: pointer;
        }
      }

      .other-date {
        display: flex;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid #eeeeee;
      }

      .con {
        padding: 6px 0;
        line-height: 25px;
        border-bottom: 1px solid #eeeeee;
        word-break: break-all;
      }
    }
  }

  .answer-box {
    height: 100%;
    display: flex;
    flex-direction: column;

    .coursewareUl,
    .answer-lists {
      flex: 1;
      overflow: auto;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .answer-types {
      display: flex;
      padding-bottom: 10px;
    }
  }

  .answer-lists {
    .item {
      margin-bottom: 20px;
      .date {
        padding: 10px 0;
        border-bottom: 1px solid #eeeeee;
      }

      .con {
        padding: 6px 0;
        line-height: 25px;

        .row {
          display: flex;
        }

        .answer-con {
          width: 260px;
          background: #eaeef1;
          padding: 10px;
        }
      }
    }
  }
}
</style>
